// extracted by css-extract-rspack-plugin
export default {"quickFilterButton":"quick-filter-shared-module__quickFilterButton__vCXtJ"};